// NOTE: if you change `COOKIE_USER_SESSION` please change `packages/store/server/preload/datadog.ts`
export const COOKIE_USER_SESSION = 'user-session';
export const COOKIE_CHECKOUT_DATA = 'checkout-data';
export const COOKIE_PRODUCT_DATA = 'product-data';
export const COOKIE_UTM_PARAMS = 'utm_params';
export const COOKIE_AUTH_REDIRECT_TO = 'auth-redirect-to';
export const COOKIE_MIXPANEL_UUID = 'mixpanel-uuid';
export const COOKIE_MIXPANEL_ENABLED = 'mixpanel-enabled';
export const SPLIT_SESSION_COOKIE = 'split.session';
